import random from 'lodash/random';
import { createSpring } from './spring';
import { remap } from './remap';
import { createAnimation } from './createAnimation';

const createLine = (size, length, color) => {
    const spring = createSpring({
        tension: 50,
        friction: 150
    });

    const p = [0, 0];
    let ps = [0, 0];
    let pd = [0, 0];

    const getBBox = () => [p[0], p[1], length, length];

    const update = () => {
        const s = spring.step();
        p[0] = remap(s, 0, 100, ps[0], pd[0]);
        p[1] = remap(s, 0, 100, ps[1], pd[1]);
    };

    const move = (d, s = ps) => {
        pd = d;
        ps = s;
        spring.reset();
    };

    const draw = ctx => {
        ctx.beginPath();
        ctx.moveTo(p[0], p[1]);
        ctx.lineTo(p[0] + length, p[1] - length);
        ctx.lineWidth = size;
        ctx.strokeStyle = color;
        ctx.stroke();
    };

    const getPosition = () => p;
    const getLength = () => length;

    return {
        update,
        draw,
        move,
        getPosition,
        getLength,
        isMoving: spring.isMoving,
        getBBox
    };
};

const colors = ['#e4e4e4', '#777777', '#c1c1c1'];
const getRandomColor = () => colors[random(0, colors.length - 1)];

const getLinesCount = (width, height) => Math.round(width * height * 0.0003);

const getLine = pool => {
    if (pool.length) return pool.pop();
    return createLine(random(0.5, 1.5), random(20, 100), getRandomColor());
};

const poolLine = (pool, line) => {
    pool.push(line);
};

const initialize = (width, height) => {
    const pool = [];
    const lines = [];
    const linesCount = getLinesCount(width, height);

    for (let i = 0; i < linesCount; i++) {
        const line = getLine(pool);
        const s = [
            random(-width * 2, width),
            height + 100 + random(height * 2)
        ];
        const d = [s[0] + 1000, s[1] - 1000];
        line.move(d, s);
        lines.push(line);
    }

    return {
        pool,
        lines
    };
};

const update = (data, width, height) => {
    const { pool, lines } = data;
    const linesNext = [];
    const linesCountNext = getLinesCount(width, height);
    const linesCount = lines.length;

    for (let i = 0; i < linesCount; i++) {
        const line = lines[i];
        const [x, y] = line.getPosition();

        if (x > width || y < 0) {
            if (linesCountNext < linesCount) {
                poolLine(pool, line);
            } else {
                const length = line.getLength();
                const s = [
                    random(-width, width),
                    height + length + random(length)
                ];
                const d = [s[0] + 1000, s[1] - 1000];
                line.move(d, s);
                line.update();
                linesNext.push(line);
            }
        } else {
            line.update();
            linesNext.push(line);
        }
    }
    if (linesNext.length < linesCountNext) {
        const leftLinesCount = linesCountNext - linesNext.length;
        for (let i = 0; i < leftLinesCount; i++) {
            const line = getLine(pool);
            const s = [
                random(-width * 2, width),
                height + 100 + random(height * 2)
            ];
            const d = [s[0] + 1000, s[1] - 1000];
            line.move(d, s);
            line.update();
            linesNext.push(line);
        }
    }

    return {
        pool: pool,
        lines: linesNext
    };
};

const draw = (ctx, data, width, height) => {
    const { lines } = data;
    ctx.clearRect(0, 0, width, height);
    for (let i = 0, l = lines.length; i < l; i++) {
        lines[i].draw(ctx);
    }
};

export const createLinesAnimation = createAnimation(initialize, update, draw);
